import { z } from 'zod';

export const Database = z.object({
  id: z.string(),
  organizationId: z.string(),
  name: z.string(),
  description: z.string(),
});

export type Database = z.infer<typeof Database>;
